<div
  class="eiq-rich-text-input__outer"
  [class.focused]="focused$()"
  [class.advanced]="isAdvancedMode$()"
  [class.invalid]="control?.invalid && control?.touched"
  [class.disabled]="isDisabled$()"
>
  <div class="eiq-rich-text-input__toolbar-bar" [hidden]="!isAdvancedMode$()">
    <div [id]="uniqueId + '-toolbar'"></div>
  </div>

  <div class="eiq-rich-text-input__body">
    <div class="eiq-rich-text-input__editor-area" (keydown)="onKeydown($event)">
      <ckeditor [editor]="editor" [config]="config" [attr.data-testid]="testId() ? testId() + '-editor' : ''" (ready)="onReady($event)"></ckeditor>
    </div>

    <div class="eiq-rich-text-input__actions">
      <div class="eiq-rich-text-input__meta">
        @if (showCharCount()) {
          <span class="eiq-rich-text-input__char-count text__xs fw__400">{{ charCount$() }} chars</span>
        }
        @if (showKeyboardHint() && displayHint$()) {
          <span class="eiq-rich-text-input__hint text__xs fw__400">· {{ displayHint$() }}</span>
        }
      </div>

      <div class="eiq-rich-text-input__right-actions">
        <eiq-icon-button
          [testId]="testId() ? testId() + '-toggle-btn' : ''"
          [icon]="faPenToSquare"
          [color]="isAdvancedMode$() ? 'primary' : 'light'"
          [size]="'large'"
          (clicked)="toggleAdvancedMode()"
        ></eiq-icon-button>

        @if (showSubmitButton()) {
          <eiq-button
            [testId]="testId() ? testId() + '-submit-btn' : ''"
            [text]="submitLabel()"
            [color]="'primary'"
            [icon]="faPaperPlaneTop"
            [disabled]="control ? !control.valid : false"
            (clicked)="onSubmit()"
          ></eiq-button>
        }
      </div>
    </div>
  </div>
</div>
